import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import store from "@/stores/index";

import Page404 from "@/errors/Page404";
import UsingToken from "@/components/UsingToken";
import App from "@/App";
import MainGame from "@/components/MainGame";
import Address from "@/components/Address";
import jwtService from "@/jwt-service";
import Rules from "@/components/Rules";
import HistoryGame from "@/components/History";
import { i18n } from "@/i18n-init";

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "game",
      component: App,
      redirect: { name: "luckyDraw" },
      children: [
        {
          path: "/:locale/lucky-draw",
          name: "luckyDraw",
          component: MainGame,
          meta: {
            classBody: "",
          },
          beforeEnter: (to, from, next) => {
            let isAuthenticate = to.params.isAuthenticate;
            let isAuthenticateStore = store.getters.isAuthenticate;
            if (isAuthenticate || isAuthenticateStore) {
              return next();
            } else {
              const token = jwtService.getToken();
              const customerPhone = jwtService.getCustomerPhone();
              if (token && customerPhone) {
                return next({
                  name: "usingToken",
                  params: { token, customerPhone },
                });
              }
              return next();
            }
          },
        },
        {
          path: "/:locale/insert-address",
          name: "insertAddress",
          component: Address,
          meta: {
            classBody: "box_ldp2 box_ldpform",
          },
          beforeEnter: (to, from, next) => {
            let isNeedInsertAddress = to.params.isNeedInsertAddress;
            if (isNeedInsertAddress) {
              return next();
            } else {
              return next({ name: "luckyDraw" });
            }
          },
        },
        {
          path: "/:locale/rules",
          name: "Rules",
          component: Rules,
          meta: {
            classBody: "box_ldp2",
          },
        },
        {
          path: "/:locale/history",
          name: "History",
          component: HistoryGame,
          meta: {
            classBody: "box_ldp2",
          },
          beforeEnter: (to, from, next) => {
            let isAuthenticate = to.params.isAuthenticate;
            let isAuthenticateStore = store.getters.isAuthenticate;
            if (isAuthenticate || isAuthenticateStore) {
              return next();
            } else {
              let token = jwtService.getToken() || "";
              const locale = to.params.locale;
              const tokenUrl = to.query.token || "";
              if (token === "") jwtService.saveToken(tokenUrl);
              if (tokenUrl !== "" && token === "") token = tokenUrl;
              return next({
                name: "usingToken",
                params: { token: token, locale: locale },
                query: { callback: "History" },
              });
            }
          },
        },
      ],
    },
    {
      path: "/:locale/using-token/:token",
      name: "usingToken",
      component: UsingToken,
    },
    {
      path: "404",
      name: "page404",
      component: Page404,
    },
    {
      path: "*",
      redirect: { name: "page404" },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const locale = to.params.locale;
  const supported_locales = "vi";
  if (!supported_locales?.includes(locale)) {
    i18n.locale = "vi";
  } else if (i18n.locale !== locale) {
    i18n.locale = locale;
  }
  return next();
});

export default router;
